// extracted by mini-css-extract-plugin
module.exports = {"entries-per-page":"_1yJ54-","entriesPerPage":"_1yJ54-","select":"h1qQT-"};